import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import {
  faComments,
  faCalendarDays,
  faUserGroup,
  faHeart,
  faBookOpen,
  faFileInvoice,
  faTableList,
  faArrowRightFromBracket,
  faChevronLeft,
  faChevronRight,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import placeholderAvatar from "./../images/placeholder-avatar.png";
import "./Dashboard.css";

const Dashboard = ({
  UserLandingData,
  setSelectedSection,
  setLogin,
  toggleSidebar,
  isSidebarOpen,
  isMobileWeb,
}) => {
  const username = localStorage.getItem("username") || "Guest";
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("userId");
    localStorage.removeItem("isAdmin");
    navigate("/");
    setLogin(false);
  };

  const switchScreen = (screen) => {
    setSelectedSection(screen);
    if (isMobileWeb) {
      toggleSidebar(false);
    }
  };

  const menuItems = [
    { name: "Messages", icon: faComments, id: "Messages" },
    { name: "Calendar", icon: faCalendarDays, id: "Calendar" },
    { name: "Provider", icon: faUserGroup, id: "Provider" },
    { name: "Services", icon: faHeart, id: "Services" },
    { name: "Booking", icon: faBookOpen, id: "Booking" },
    { name: "Self/Family", icon: faFileInvoice, id: "Patient" },
    { name: "Account", icon: faTableList, id: "Account" },
  ];

  return (
    <>
      {isMobileWeb && isSidebarOpen && (
        <div
          className="dashboard-overlay"
          onClick={() => toggleSidebar(false)}
        ></div>
      )}

      <aside
        className={`modern-dashboard ${isSidebarOpen ? "open" : "closed"}`}
      >
        <div className="dashboard-header">
          {isMobileWeb ? (
            /* Mobile: full close button (X) */
            <>
              {isSidebarOpen && <span className="logo-text">Menu</span>}
              <button
                className="toggle-btn toggle-btn-close"
                onClick={() => toggleSidebar(false)}
                aria-label="Close sidebar"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </>
          ) : (
            /* Desktop: chevron collapse/expand */
            <>
              {isSidebarOpen && <span className="logo-text"></span>}
              <button
                className="toggle-btn"
                onClick={() => toggleSidebar()}
                aria-label={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
              >
                <FontAwesomeIcon
                  icon={isSidebarOpen ? faChevronLeft : faChevronRight}
                />
              </button>
            </>
          )}
        </div>

        <div className="dashboard-profile-section">
          <div className="dashboard-avatar-wrapper">
            <img src={placeholderAvatar} alt="Profile" />
          </div>
          {isSidebarOpen && (
            <div className="dashboard-user-info">
              <h4>{username}</h4>
              <p>Member</p>
            </div>
          )}
        </div>

        <nav className="dashboard-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className="nav-item"
              id={`${item.id.toLowerCase()}-button`}
              onClick={() => switchScreen(item.id)}
            >
              <FontAwesomeIcon className="nav-icon" icon={item.icon} />
              {isSidebarOpen && <span className="nav-text">{item.name}</span>}
            </button>
          ))}
        </nav>

        <div className="dashboard-footer">
          <button className="nav-item logout-btn" onClick={handleLogout}>
            <FontAwesomeIcon
              className="nav-icon"
              icon={faArrowRightFromBracket}
            />
            {isSidebarOpen && <span className="nav-text">Logout</span>}
          </button>
        </div>
      </aside>
    </>
  );
};

export default Dashboard;
